<template>
  <div>
    <div id="indexmap" :style="{ visibility: !loading ? 'hidden' : 'visible' }">
      <!-- <p>地图生成中...</p> -->
    </div>
    <div class="input-card" style="width:16rem">
      <div id="btns" class="btn_map">
        <div class="input-item">
          <el-button size="mini" class="amap_move" style="margin-right:1px;" v-if="isShowReturnBtn"
                     @click="returnMap('returnMap')">流入图</el-button>
          <el-button size="mini" class="amap_move" style="margin-right:1px;" v-if="isShowRentBtn"
                     @click="rentMap('rentMap')">流出图</el-button>
          <el-button id="destroy-btn" size="mini" class="amap_move" v-if="isShowAmapBtn"
                     @click="destroyMap(true)">主地图</el-button>
          <div  style="margin-bottom: 565px;margin-left: 30px" v-if="isShowPolygonSumBtn||isShowPolygonBtn">
          <el-button id="polygonSum" size="mini" class="amap_polygon" v-if="isShowPolygonSumBtn">
            <span style="color: #a1a5aa">站点数：</span>
            <span style="color: white">{{PolygonSum}}</span>
            <span style="margin-right: 10px"></span>
            <span style="color: #a1a5aa;">车辆数：</span>
            <span style="color: white">{{bikePolygonSum}}</span>
            <span style="margin-right: 10px"></span>
            <span style="color: #a1a5aa;">站外还车数：</span>
            <span style="color: white">{{outSidePolygonSum}}</span>
          </el-button>
          <el-button id="cleanPolygon" size="mini" class="amap_cleanPolygon" v-if="isShowPolygonBtn"
                     @click.stop.prevent="cleanPolygonConfirm">清除折线图</el-button>
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/image/重点.png" @click="togglekeynote" v-if="!isHidekeynote" class="btn5" alt="重点区域隐藏" title="重点"/>
    <img src="@/assets/image/隐藏.png" @click="togglekeynote" v-else class="btn5" alt="重点区域显示" title="重点区域"/>
    <img
      src="@/assets/image/站点显示.png"
      @click="togglelayer"
      v-if="!isHideLayer"
      class="btn1"
      title="车辆"
      alt="站点隐藏"
    />
    <img src="@/assets/image/隐藏.png" @click="togglelayer" v-else class="btn1" title="车辆" alt="站点显示" />
        <img
      src="@/assets/image/围栏显示.png"
      @click="toggleOverlay"
      v-if="!isHideOverlay"
      class="btn2"
      title="围栏"
      alt="围栏隐藏"
    />
    <img src="@/assets/image/隐藏.png" @click="toggleOverlay" v-else class="btn2" title="围栏" alt="围栏显示"/>
    <img
      src="@/assets/image/热力图.png"
      v-if="isShowHeatmap"
      @click="onBikeHeatmap"
      class="btn3"
      title="热力图"
      alt="热力图隐藏"
    />
    <img src="@/assets/image/隐藏.png" @click="onBikeHeatmap" v-else class="btn3" title="热力图" alt="热力图显示"/>
    <img
      src="@/assets/image/绘制围栏.png"
      v-if="railSwitch"
      @click="changeSwitch"
      class="btn4"
      title="关闭绘制围栏"
      alt="绘制围栏隐藏"
    />
    <img :class="polygonStyle?'polygonStyleOne' : 'polygonStyleTwo'" src="@/assets/image/隐藏.png" @click="changeSwitch" v-else class="btn4" title="激活绘制围栏" alt="绘制围栏显示"/>
  </div>
</template>

<script>
import { dateFormat } from '@/utils/tools'
import Api from '@/api'
import echarts from 'echarts'
import 'echarts/lib/component/markPoint'
import Utils from '@/assets/js/util'
import {
  blue1,
  blue2,
  blue4,
  red1,
  red2,
  red4,
  yellow1,
  yellow2,
  yellow4,
  orange1,
  orange2,
  orange4,
  green1,
  green2,
  green4,
  blue3,
  orange3,
  yellow3,
  blue5,
  blue6,
  red5,
  red6,
  orange5,
  orange6,
  orange7,
  orange8,
  green5,
  green6,
  yellow5,
  yellow6,
  purple1,
  purple2,
  green7,
  green8,
  green,
  red,
  pink,
  purple,
  blue,
  orange,
  yellow,
  qing,
  blue7,
  yellow7,
  green9,
  orange9,
  red7,
  castBlue,
  castRed,
  castYellowBicycle,
  castYellowBike,
  castGreen,
  castOrange,
  castPurple,
  castQing,
  cast1,
  cast2,
  cast3,
  cast4,
  cast5,
  cast6,
  strideBlue,
  strideRed,
  strideYellowBike,
  strideGreen,
  strideOrange,
  stridePurple,
  strideQing,
  strideYellowish,
  stride1,
  stride2,
  stride3,
  stride4,
  stride5,
  Illegal1,
  Illegal2,
  Illegal3,
  Illegal4,
  Illegal5,
  Illegal6,
  Illegal7,
  Illegal8,
  Illegal9,
  Illegal10,
  Illegal11,
  Illegal12,
  Illegal13,
  Illegal14,
  outside1,
  outside2,
  outside3,
  outside4,
  outside5
} from '../components/icon'
var vm = null
var AMap = window.AMap
export default {
  name: 'Amap',
  props: {
    tableData: {
      type: Object
    },
    mapData: {
      type: Array,
      default() {
        return []
      }
    },
    selfAreaId: {
      type: [String, Number]
    },
    selfAddress: {
      type: String
    },
    currMap: {
      type: [Array, Object]
    },
    fullPileNum: {
      type: Number
    },
    userLevel: {
      type: Number
    },
    showRatioEdit: {
      type: Boolean,
      default: false
    },
    isHideLayer: {
      type: Boolean,
      default: false
    },
    isHideOverlay: {
      type: Boolean,
      default: false
    },
    ratioSites: {
      type: [Array],
      defalult() {
        return []
      }
    },
    tableDataBrands: {
      type: [Array]
    },
    sizezoom: {
      type: Number,
      default: 14
    },
    isHidekeynote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      center: [],
      green,
      red,
      pink,
      purple,
      blue,
      orange,
      yellow,
      qing,
      blue1,
      blue2,
      blue4,
      red1,
      red2,
      red4,
      yellow1,
      yellow2,
      yellow4,
      orange1,
      orange2,
      orange4,
      green1,
      green2,
      green4,
      blue3,
      orange3,
      yellow3,
      blue5,
      blue6,
      red5,
      red6,
      orange5,
      orange6,
      orange7,
      orange8,
      green5,
      green6,
      yellow5,
      yellow6,
      purple1,
      purple2,
      green7,
      green8,
      castBlue,
      castRed,
      castYellowBicycle,
      castYellowBike,
      castGreen,
      castOrange,
      castPurple,
      castQing,
      loading: true,
      key: '0b2718f15a7c8176bba6f4fdb787a101',
      map: {},
      infoWindow: {}, // 窗体只允许展示一个,
      currentData: null,
      mapList: [],
      layer: null,
      // 绘图相关
      geometries: [],
      geometriesNoRail: [],
      geometriesSite: [],
      geometriesOnStoppingFence: [], // 禁停区
      cachePolygon: [],
      // 缓存地图信息
      cacheMapZoom: null,
      cacheMapCenter: null,
      heatmap: null,
      isShowHeatmap: false,
      isShowRentBtn: false,
      isShowReturnBtn: false,
      isShowAmapBtn: false,
      isShowPolygonBtn: false,
      isShowPolygonSumBtn: false,
      // 流向图数据
      chartData: null,
      // 流出图缓存数据
      rentData: [],
      // 流入图缓存数据
      returnData: [],
      overlays: [],
      PolygonSum: 0,
      bikePolygonSum: 0,
      outSidePolygonSum: 0,
      railSwitch: false,
      polygonStyle: true
    }
  },
  mounted() {
    vm = this
    if (vm.selfAddress) {
      vm.markLocation('indexmap', vm.selfAddress)
    } else {
      vm.markLocation('indexmap', '北京')
    }
    const that = this
    Utils.$on('cleanPolygon',function (msg) {
      console.log(msg,'msg')
      that.railSwitch = false
      that.polygonStyle = false
      console.log(that.railSwitch,'that.railSwitch')
      that.cleanPolygon()
    })
  },
  methods: {
    togglekeynote() {
      // 切换重点站点
      this.$emit('togglekeynote')
    },
    togglelayer() {
      if (this.layer) {
        if (!this.isHideLayer) {
          this.layer.hide()
        } else {
          if (!this.isHidekeynote) {
            vm.$emit('refreshMap', vm.map.getCenter())
          }
          this.layer.show()
        }
        this.chartBikeMap()
      }
      this.$emit('update:isHideLayer', !this.isHideLayer)
    },
    // 流向图显示站点车辆
    chartBikeMap() {
      if (this.chartData) {
        if (this.isShowReturnBtn) {
          if (!this.isHideLayer) {
            this.rentMap(this.chartData, 'isHideLayer')
          } else {
            this.rentMap(this.chartData, 'isShowLayer')
          }
        }
        if (this.isShowRentBtn) {
          if (!this.isHideLayer) {
            this.returnMap(this.chartData, 'isHideLayer')
          } else {
            this.returnMap(this.chartData, 'isShowLayer')
          }
        }
      }
    },
    toggleOverlay() {
      var overlayGroup = new AMap.OverlayGroup(this.cachePolygon)
      if (overlayGroup) {
        if (!this.isHideOverlay) {
          overlayGroup.hide()
        } else {
          vm.$emit('refreshMap', vm.map.getCenter())
          overlayGroup.show()
        }
      }
      this.$emit('update:isHideOverlay', !this.isHideOverlay)
    },
    jjSearchFromHistory(val) {
      if ((val && val.lon && val.lat) || (val && val.bikeLon && val.bikeLat)) {
        vm.map.setZoom(this.sizezoom)
        val.siteLon = val.lon || val.bikeLon
        val.siteLat = val.lat || val.bikeLat
        val.isBike = true
        val.isBikeShowInfo = true
        vm.initMap([val, ...vm.tableData.map], null, true)
      } else {
        vm.$message.warning('搜索不到您要的信息，请重新搜索')
      }
    },
    handleBikeSearch(val) {
      console.log(val, 'bike')
      const vm = this
      if (
        val &&
        val.isOutSite &&
        val.isOutSite === 1 &&
        val.bike &&
        val.bike.bikeStatus === 1
      ) {
        // 站外还车: 效果显示车辆图标，点击图片可以展示车辆品牌和车辆编号
        val.bike.isBikeShowInfo = true // 额外字段
        vm.jjSearchFromHistory(val.bike)
      } else if (val && !val.bike) {
        // 不在库里: 提示没有车辆数据 get
        vm.$message.warning('没有相关数据，请重新搜索')
      } else if (val && val.bike && val.bike.bikeStatus === 1) {
        // 在站点: 效果站点气泡放大，周围气泡保持不变 get
        if (val.map && val.map.length) {
          // 查看是不是在站点
          const data = val.map[0]
          vm.map.setZoom(this.sizezoom)
          vm.$set(vm.tableData, 'map', [...vm.tableData.map, data])
          vm.initMap(vm.tableData.map, data)
        } else {
          vm.$message.warning('该车辆不在站点')
        }
      } else if (
        val &&
        val.isOutSite &&
        val.isOutSite === 1 &&
        val.bike &&
        val.bike.bikeStatus === 2
      ) {
        // 在出租中: 提示车辆出租中无法定位 get
        vm.$message.warning('车辆出租中无法定位')
      }
    },
    searchMap(val) {
      console.log(val)
      // 010579010129
      // val.map 模糊查询，val.bike 精准查询
      if (val && val.map && val.map.length > 1 && !val.bike) {
        // 模糊查询
        vm.initMap(val.map)
      } else if (val && val.map && val.map.length === 1 && !val.bike) {
        const data = val.map[0]
        vm.initMap(vm.tableData.map, data)
      } else if (val && val.bike) {
        // 精准查询
        vm.handleBikeSearch(val)
      } else {
        if (val && val.bike === null) {
          vm.$message.warning('没有相关数据，请重新搜索')
        } else {
          vm.$message.warning('搜索不到您要的信息，请重新搜索')
        }
      }
    },
    delSiteAndShowMap(mapList, currentMap, isBike) {
      const vm = this
      if (vm.map && vm.map.destroy) vm.map.destroy()
      vm.map = null
      vm.map = new AMap.Map('indexmap', {
        zoom: vm.cacheMapZoom,
        animateEnable: false,
        center: [vm.cacheMapCenter.lng, vm.cacheMapCenter.lat],
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        resizeEnable: false, // 是否监控地图容器尺寸变化
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false,
        mapStyle: 'amap://styles/blue'
        // mapStyle: "amap://styles/98d9933e4bf082af3c1c63d524ceefaf", // 设置地图的显示样式
      })
      // 当前是根据areaid获取整个area的所有站点，此绑定方法废弃
      vm.map.on('zoomend', vm.zoomend)
      vm.map.on('movestart', vm.mapMovestart)
      vm.map.on(
        'mapmove',
        vm.throttle(() => {
          vm.$emit('clearMapTimer')
        })
      )
      vm.map.on('moveend', vm.mapMoveend)
      vm.showMapIcon(mapList, currentMap)
      // 初始化围栏 - 1
      if (this.userLevel >= 2) {
        this.getRails()
      }
    },
    throttle(fn, delay = 1500) {
      let valid = true
      return function () {
        if (!valid) {
          // 休息时间 暂不接客
          return false
        }
        // 工作时间，执行函数并且在间隔期内把状态位设为无效
        valid = false
        setTimeout(() => {
          fn()
          valid = true
        }, delay)
      }
    },
    mapmove() {
      this.$emit('clearMapTimer')
    },
    mapMoveendBike() {
      this.map.addLayer(vm.layer)
    },
    initBikeMap(bikelist) {
      if (bikelist && bikelist.length) {
        if (vm.map && vm.map.destroy) vm.map.destroy()
        vm.map = null
        vm.map = new AMap.Map('indexmap', {
          zoom: (bikelist[0].legality === 14) ? 12 : this.sizezoom,
          animateEnable: false,
          center: vm.center,
          viewMode: '2D',
          zoomEnable: true, // 是否可滚轮缩放
          dragEnable: true, // 是否可拖拽
          resizeEnable: false, // 是否监控地图容器尺寸变化
          keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
          showLabel: true,
          expandZoomRange: false,
          pitch: 60, // 3d有效
          showIndoorMap: false,
          mapStyle: 'amap://styles/blue'
          // mapStyle: "amap://styles/98d9933e4bf082af3c1c63d524ceefaf", // 设置地图的显示样式
        })
        vm.map.on('movestart', vm.mapMovestart)
        vm.map.on('moveend', vm.mapMoveendBike)
        vm.layer = new AMap.LabelsLayer({
          map: vm.map,
          zooms: [3, 20],
          zIndex: 201,
          collision: false,
          allowCollision: false
        })
        vm.map.addLayer(vm.layer)
        var markers = []
        bikelist.forEach((mark) => {
          const marker = new AMap.LabelMarker({
            name: mark.siteName,
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: 'image',
              // 图片 url
              image: this.getIcon2(mark.brandName, mark.legality),
              // 图片尺寸
              size: [34, 48],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: 'center'
            },
            opacity: 1,
            zooms: [3, 20],
            id: mark.siteId,
            position: [
              mark.bikeLon != undefined ? mark.bikeLon : mark.lon,
              mark.bikeLat != undefined ? mark.bikeLat : mark.lat
            ],
            zIndex: 300
          })
          marker.on('click', vm.showBikeInfoMBikeFeiFa.bind(vm, mark))
          markers.push(marker)
        })
        console.log(markers)
        vm.layer.add(markers)
      }
      // 初始化围栏 - 1
      if (this.userLevel >= 2) {
        this.getRails()
      }
    },
    initBikeMap2(bikelist) {
      if (bikelist && bikelist.length) {
        if (vm.map && vm.map.destroy) vm.map.destroy()
        vm.map = null
        vm.map = new AMap.Map('indexmap', {
          zoom: this.sizezoom,
          animateEnable: false,
          center: [bikelist[0].siteLon, bikelist[0].siteLat],
          viewMode: '2D',
          zoomEnable: true, // 是否可滚轮缩放
          dragEnable: true, // 是否可拖拽
          resizeEnable: false, // 是否监控地图容器尺寸变化
          keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
          showLabel: true,
          expandZoomRange: false,
          pitch: 60, // 3d有效
          showIndoorMap: false,
          mapStyle: 'amap://styles/blue'
          // mapStyle: "amap://styles/98d9933e4bf082af3c1c63d524ceefaf", // 设置地图的显示样式
        })
        vm.map.on('movestart', vm.mapMovestart)
        vm.map.on(
          'mapmove',
          vm.throttle(() => {
            vm.$emit('clearMapTimer')
          })
        )
        vm.map.on('moveend', vm.mapMoveendBike)
        vm.layer = new AMap.LabelsLayer({
          map: vm.map,
          zooms: [3, 20],
          zIndex: 201,
          collision: false,
          allowCollision: false
        })
        vm.map.addLayer(vm.layer)
        var markers = []
        bikelist.forEach((mark) => {
          const marker = new AMap.LabelMarker({
            name: mark.siteName,
            icon: {
              // 图标类型，现阶段只支持 image 类型
              type: 'image',
              // 图片 url
              image: this.getIcon3(mark.brandName).url,
              // 图片尺寸
              size: [26, 40],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: 'center'
            },
            opacity: 1,
            zooms: [3, 20],
            id: mark.siteId,
            position: [mark.siteLon, mark.siteLat],
            zIndex: 300,
            text: {
              content: mark.num + '',
              direction: 'center',
              offset: [0, -10],
              style: {
                fontSize: 12,
                fillColor: this.getIcon3(mark.brandName).color
              }
            }
          })
          marker.on('click', vm.showInfoM.bind(vm, mark))
          markers.push(marker)
        })
        vm.layer.add(markers)
      }
      // 初始化围栏 - 1
      if (this.userLevel >= 2) {
        this.getRails()
      }
    },
    initMap(mapList, currentMap, isBike, isMovedMap) {
      // todo 目前center写死
      // console.log(111, 'initMap', mapList, currentMap, isMovedMap)
      this.loading = true
      vm.mapList = mapList
      if (mapList && mapList.length) {
        const firstSite = mapList[0]
        this.center =
          currentMap && currentMap.siteId
            ? [currentMap.siteLon, currentMap.siteLat]
            : firstSite
              ? [firstSite.siteLon, firstSite.siteLat]
              : [116.397428, 39.90923]
        if (!isMovedMap) {
          vm.map = new AMap.Map('indexmap', {
            resizeEnable: true, // 允许缩放
            center: this.center, // 设置地图的中心点
            zoom:
              (currentMap && currentMap.siteId) || isBike ? 18 : this.sizezoom, // 设置地图的缩放级别，0 - 20
            animateEnable: false,
            viewMode: '2D',
            zoomEnable: true, // 是否可滚轮缩放
            dragEnable: true, // 是否可拖拽
            keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
            doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
            showLabel: true,
            expandZoomRange: false,
            pitch: 60, // 3d有效
            showIndoorMap: false,
            // mapStyle: "amap://styles/3096a22a0f89687a460606c737005cac",
            mapStyle: 'amap://styles/blue' // 设置地图的显示样式
          })
          // 显示热力图
          this.createHeatMap(mapList)
          // vm.map.setZoom(((currentMap && currentMap.siteId) || isBike) ? 18 : this.sizezoom)
          // vm.map.setCenter((currentMap && currentMap.siteId) ? [currentMap.siteLon, currentMap.siteLat] : (firstSite ? [firstSite.siteLon, firstSite.siteLat] : [116.397428, 39.90923]))
        } else {
          vm.map.remove(vm.layer)
          vm.map.removeLayer(vm.layer)
          vm.clearSiteGpsRail()
        }
        vm.$emit('refreshCenter', vm.map.getCenter())
        // 当前是根据areaid获取整个area的所有站点，此绑定方法废弃
        vm.map.on('zoomend', vm.zoomend)
        vm.map.on('movestart', vm.mapMovestart)
        vm.map.on('moveend', vm.mapMoveend)
        vm.map.on(
          'mapmove',
          vm.throttle(() => {
            vm.$emit('clearMapTimer')
          })
        )
        vm.showMapIcon(mapList, currentMap)
        // 初始化围栏 - 1
        // 移动地图不需要重新禁行区和禁停区
        if (!isMovedMap && vm.userLevel >= 2) {
          vm.getRails()
        }
        // 如果是移动地图，重新绘制站点围栏
        if (isMovedMap && !vm.isHideOverlay) {
          vm.zoomend({
            type: 'zoomend'
          })
        }
      } else {
        if (vm.selfAddress) {
          vm.markLocation('indexmap', vm.selfAddress)
        } else {
          vm.markLocation('indexmap', '')
        }
      }
    },
    // 绘制多边形统计站点数量
    drawPolygonSum() {
      const vm = this
      // 悬浮提示窗体
      const tipWin = new AMap.InfoWindow({
        content: '<div style="color: #edf0f6;">单击开始，双击结束绘制</div>',
        offset: new AMap.Pixel(12, 12),
        autoMove: false,
        closeWhenClickMap: false
      })
      // 通过插件方式引入 AMap.MouseTool 工具
      vm.map.plugin('AMap.MouseTool', function() {
        // 先清除已有MouseTool实例（防止多实例绘制）
        if (vm.mouseTool) {
          vm.mouseTool.close()
          vm.mouseTool = null
        }

        var mouseTool = new AMap.MouseTool(vm.map)
        vm.mouseTool = mouseTool // 挂载到实例，方便后续销毁

        const mouseDrawPolygon = mouseTool.polygon({
          fillOpacity: 0.2
        })
        // 鼠标移动实时打开提示
        const moveFn = (e) => {
          tipWin.open(vm.map, e.lnglat)
        }
        vm.map.on('mousemove', moveFn)
        // 绘制完成/取消关闭提示、解绑事件
        const closeTip = () => {
          tipWin.close()
          vm.map.off('mousemove', moveFn)
        }
        vm.mouseTool.on('draw', closeTip)
        vm.mouseTool.on('drawcancel', closeTip)
        // 绘制前先清空旧的overlay（防止叠加）
        if (vm.overlays.length > 0) {
          vm.overlays.forEach(overlay => vm.map.remove(overlay))
          vm.overlays = []
        }
        // 用鼠标工具画多边形
        mouseTool.on('draw', function(e) {
          // 强制只保留最新的1个图形
          if (vm.overlays.length >= 1) {
            vm.map.remove(vm.overlays[0])
            vm.overlays.shift()
          }
          vm.overlays.push(e.obj)
        })
        AMap.event.addListener(mouseTool, 'draw', function (e) { // 添加事件
          console.log(e.obj._opts.path, '获取多边形路径')// 获取路径/范围
          // 获取站外还车的经纬度
          var outSideArr = []
          const params = {
            selfAreaId: vm.selfAreaId,
            legality: 1,
            mold: 1
          }
          Api.dashboardBike(params).then((res) => {
            res.data.forEach((val) => {
              outSideArr.push([val.bikeLon, val.bikeLat])
            })
            var point = []
            vm.mapList.forEach((item) => {
              point.push([item.siteLon, item.siteLat, item.currentNum])
            })
            // 统计绘制围栏中站点总数
            var siteNum = 0
            // 统计绘制围栏中车辆总数
            var bikeNum = 0
            // 统计绘制围栏中站外还车总数
            var outSideNum = 0
            point.forEach(item => {
              var isPointInRing = AMap.GeometryUtil.isPointInRing(item, e.obj._opts.path)
              if (isPointInRing) {
                siteNum = siteNum + 1
                bikeNum = bikeNum + item[item.length - 1]
              }
            })
            outSideArr.forEach(item => {
              var isPointInRing = AMap.GeometryUtil.isPointInRing(item, e.obj._opts.path)
              if (isPointInRing) {
                outSideNum = outSideNum + 1
              }
            })
            if (vm.overlays.length === 1) {
              vm.PolygonSum = siteNum
              vm.bikePolygonSum = bikeNum
              vm.outSidePolygonSum = outSideNum
              vm.isShowPolygonBtn = true
              vm.isShowPolygonSumBtn = true
            }
          })
        })
      })
    },
    // 清除绘制多边形
    cleanPolygon() {
      // 1. 先校验地图实例是否存在
      if (!this.map) {
        console.warn('地图实例不存在，无法清除图形')
        this.resetPolygonState()
        return
      }

      try {
        // 2. 清除绘制的多边形（统计用）
        if (this.overlays && this.overlays.length) {
          // 遍历移除所有overlay，确保逐个清理
          this.overlays.forEach(overlay => {
            if (overlay && overlay.remove) {
              overlay.remove() // 实例自身移除方法
            } else if (this.map.remove) {
              this.map.remove(overlay) // 地图层面移除
            }
          })
          this.overlays = [] // 清空缓存，必须同步
        }

        // 3. 清除站点围栏多边形（cachePolygon）
        if (this.cachePolygon && this.cachePolygon.length) {
          this.cachePolygon.forEach(polygon => {
            if (polygon && polygon.remove) {
              polygon.remove()
            } else if (this.map.remove) {
              this.map.remove(polygon)
            }
          })
          this.cachePolygon = [] // 清空缓存
        }

        // 4. 重置状态（避免残留显示）
        this.resetPolygonState()

        console.log('图形清除成功')
      } catch (e) {
        console.error('清除图形失败：', e)
        // 兜底重置状态
        this.resetPolygonState()
      }
    },
    cleanPolygonConfirm() {
      this.showConfirm('温馨提示', '你是否确定清除绘制的图形？', () => {
        // 强制触发地图重绘 + 清除
        this.$nextTick(() => {
          this.cleanPolygon()
          // 额外兜底：移除地图上所有未被缓存的多边形（防止缓存丢失）
          if (this.map && this.map.getAllOverlays) {
            const allOverlays = this.map.getAllOverlays('polygon')
            if (allOverlays && allOverlays.length) {
              this.map.remove(allOverlays)
            }
          }
        })
      })
    },
    // 新增：重置多边形相关状态
    resetPolygonState() {
      this.isShowPolygonBtn = false
      this.isShowPolygonSumBtn = false
      this.PolygonSum = 0
      this.bikePolygonSum = 0
      this.outSidePolygonSum = 0
      this.railSwitch = false
      this.polygonStyle = true
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        successFn && successFn.call(this)
      }).catch(() => {
        failFn && failFn.call(this)
      })
    },
    // 判断浏览区是否支持canvas
    isSupportCanvas() {
      const elem = document.createElement('canvas')
      return !!(elem.getContext && elem.getContext('2d'))
    },
    // 创建热力图
    createHeatMap(mapList) {
      const heatmapData = []
      let count
      const that = this
      const bikeMapList = JSON.parse(JSON.stringify(mapList))
      bikeMapList.forEach((mark) => {
        if (mark.flag === 0) {
          count = 0 // 空桩
        } else if (mark.flag === 4) {
          count = 5 // 偏少
        } else if (mark.flag === 3) {
          count = 15 // 偏多
        } else if (mark.flag === 2) {
          count = 20 // 满桩
        } else {
          count = 10 // 正常
        }
        const item = {
          lng: mark.siteLon,
          lat: mark.siteLat,
          count: count
        }
        heatmapData.push(item)
      })
      console.log('heatmapData:', heatmapData)
      if (!this.isSupportCanvas()) {
        this.$message.error(
          '热力图仅对支持canvas的浏览器适用,您所使用的浏览器不能使用热力图功能,请换个浏览器试试。'
        )
      }
      const zoomLevel = that.map.getZoom()
      vm.map.plugin('AMap.HeatMap', function() {
        // 初始化heatmap对象
        that.heatmap = new AMap.HeatMap(vm.map, {
          radius: (zoomLevel - 10) * 10, // 给定半径
          opacity: [0, 0.3],
          blur: 0.8, // 一个点外圈和内圈的大小比例，值越大，内圈占的比例就越大；值越小，外圈占的比例就越大
          gradient: {
            0.5: 'blue',
            0.65: 'rgb(117,211,248)',
            0.7: 'rgb(0, 255, 0)',
            0.9: '#ffea00',
            1.0: 'red'
          }
        })
        // max得合理取值，太小会几乎一片红色，太大几乎看不到热力图颜色，在此项目中max取城市中所有点count平均值
        // 设置数据集
        if (that.heatmap) {
          that.heatmap.setDataSet({
            data: heatmapData,
            max: 17
          })
          that.heatmap.hide()
        } else {
          that.heatmap.setDataSet({ data: [] })
        }
      })
    },
    // 显示和隐藏热力图
    onBikeHeatmap() {
      if (this.chartData) {
        this.chartHeatMap()
      }
      if (this.isShowHeatmap) {
        this.isShowHeatmap = false
        this.heatmap.hide()
      } else {
        this.isShowHeatmap = true
        this.heatmap.show()
      }
    },
    addHeatMapEvent(zoomLevel) {
      const _this = this
      _this.map.on('zoomchange', function (e) {
        console.log((zoomLevel - 10) * 10, 'zoomLevel')
        _this.heatmap.setOptions({
          radius: (zoomLevel - 10) * 10
        })
      })
    },
    // 流向图显示热力图
    chartHeatMap() {
      // 销毁实例
      echarts.init(document.getElementById('indexmap')).dispose()
      vm.map = new AMap.Map('indexmap', {
        resizeEnable: true, // 允许缩放
        center: this.center, // 设置地图的中心点
        zoom: vm.map.getZoom(),
        animateEnable: false,
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false,
        mapStyle: 'amap://styles/blue' // 设置地图的显示样式
      })
      // 显示热力图
      this.createHeatMap(this.mapList)
      // 清除绘制多边形围栏
      this.cleanPolygon()
      this.railSwitch = false
      this.polygonStyle = true
      this.showMapIcon(this.mapList, null)
      this.onShowAmapBtn(false, false, false)
    },
    zoomend(ev) {
      const zoom = this.map.getZoom()
      this.cacheMapZoom = zoom
      this.cacheMapCenter = this.map.getCenter()
      console.log(
        '当前地图信息：',
        'zoom: ',
        zoom,
        'center: ',
        this.cacheMapCenter,
        ev
      )
      if (ev && ev.type === 'zoomend' && zoom >= 17) {
        if (this.mapList && this.mapList.length && !this.cachePolygon.length) {
          this.initSiteGpsRail()
        }
      } else {
        this.clearSiteGpsRail()
      }
      this.$emit('clearMapTimer')
      this.addHeatMapEvent(zoom)
    },
    // 初始化围栏 - 1 / 2
    async getRails() {
      if (this.isHideOverlay) {
        return
      }
      const vm = this
      const res = await vm.getRail()
      if (res && res.code === 200 && res.data && res.data.length) {
        vm.geometries = []
        res.data.forEach((item) => {
          if (
            item.gpsRally &&
            JSON.parse(item.gpsRally) &&
            JSON.parse(item.gpsRally)[0] &&
            JSON.parse(item.gpsRally)[0].id
          ) {
            const gpsRally = JSON.parse(item.gpsRally)
            gpsRally.forEach((pgs) => {
              const length = pgs.paths && pgs.paths.length
              if (length) {
                const paths = []
                pgs.paths.forEach((path) => {
                  paths.push(new AMap.LngLat(path.lng, path.lat))
                })
                vm.geometries.push({
                  paths
                })
              }
            })
          }
        })
      }
      // 新版 - 禁停区
      const onStoppingFence = await vm.getOnStoppingFence()
      // console.log('onStoppingFence', onStoppingFence)
      if (
        onStoppingFence &&
        onStoppingFence.code === 200 &&
        onStoppingFence.data &&
        onStoppingFence.data.length
      ) {
        vm.geometriesOnStoppingFence = []
        onStoppingFence.data.forEach((item) => {
          if (
            item.fence &&
            JSON.parse(item.fence) &&
            JSON.parse(item.fence).length
          ) {
            const fence = JSON.parse(item.fence)
            const paths = []
            fence.forEach((pgs) => {
              paths.push(new AMap.LngLat(pgs.lon, pgs.lat))
            })
            vm.geometriesOnStoppingFence.push({
              paths
            })
          }
        })
      }

      // 禁行区
      const noRail = await vm.getForbiddenZone()
      if (noRail && noRail.code === 200 && noRail.data && noRail.data.length) {
        vm.geometriesNoRail = []
        noRail.data.forEach((item) => {
          if (
            item.fence &&
            JSON.parse(item.fence) &&
            JSON.parse(item.fence).length
          ) {
            const fence = JSON.parse(item.fence)
            const paths = []
            fence.forEach((pgs) => {
              paths.push(new AMap.LngLat(pgs.lon, pgs.lat))
            })
            vm.geometriesNoRail.push({
              paths
            })
          }
        })
      }
      vm.initRailMap()
    },
    // 新版禁停区
    getOnStoppingFence() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          type: 0 // 0=禁停区,1=禁行区
        }
        Api.getForbidList(params)
          .then((res) => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning('获取新版禁停区')
              reject(res)
            }
          })
          .catch((err) => {
            console.log('获取新版禁停区：', err)
            reject(err)
          })
      })
    },
    // 禁行区
    getForbiddenZone() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          type: 1 // 0=禁停区,1=禁行区
        }
        Api.getForbidList(params)
          .then((res) => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning('获取新版禁停区')
              reject(res)
            }
          })
          .catch((err) => {
            console.log('获取新版禁停区：', err)
            reject(err)
          })
      })
    },
    // 站点围栏绘图
    clearSiteGpsRail() {
      if (this.cachePolygon.length) {
        this.cachePolygon.forEach((polygon) => polygon.remove())
        this.cachePolygon = []
      }
    },
    initSiteGpsRail() {
      if (this.isHideOverlay) {
        return
      }
      vm.geometriesSite = []
      const siteList = []
      vm.mapList.forEach((item) => {
        if (item.gpsRail) {
          const gpsRail = JSON.parse(item.gpsRail)
          if (gpsRail.length) {
            const paths = []
            gpsRail.forEach((path) => {
              paths.push(new AMap.LngLat(path.lon, path.lat))
            })
            vm.geometriesSite.push({
              paths
            })
            siteList.push(item)
          }
        }
      })
      // console.log('站点围栏集合', vm.geometriesSite, siteList)
      if (vm.geometriesSite && vm.geometriesSite.length) {
        vm.geometriesSite.forEach((path) => vm.drawPolygon(path.paths, 'site'))
      }
    },
    // 统一调用绘图函数
    initRailMap() {
      // console.log('initMap', location)
      const vm = this
      // 初始化几何图形及编辑器
      if (vm.geometries && vm.geometries.length) {
        vm.geometries.forEach((path) => vm.drawPolygon(path.paths, 'rail'))
      }
      if (vm.geometriesNoRail && vm.geometriesNoRail.length) {
        vm.geometriesNoRail.forEach((path) =>
          vm.drawPolygon(path.paths, 'noRail')
        )
      }
      // 禁停区
      if (vm.geometriesOnStoppingFence && vm.geometriesOnStoppingFence.length) {
        vm.geometriesOnStoppingFence.forEach((path) =>
          vm.drawPolygon(path.paths, 'onStoppingFence')
        )
      }
    },
    // 绘图函数
    drawPolygon(path, type) {
      const vm = this
      let strokeColor
      let fillColor
      let strokeStyle
      let strokeWeight
      if (type === 'rail') {
        // 区域围栏边界颜色为蓝色
        strokeColor = '#1890FF'
        fillColor = ''
        strokeStyle = 'dashed'
        strokeWeight = 2
      } else if (type === 'noRail') {
        // 禁行区为红色边界红色阴影
        strokeColor = '#E6352C'
        fillColor = '#E6352C'
        strokeStyle = 'dashed'
        strokeWeight = 2
      } else if (type === 'site') {
        // 站点围栏为蓝色虚线加蓝色阴影
        strokeColor = '#1890FF'
        fillColor = '#1890FF'
        strokeStyle = 'dashed'
        strokeWeight = 1
      } else if (type === 'onStoppingFence') {
        // 禁停区为黄色虚线加黄色阴影
        strokeColor = '#FFC414'
        fillColor = '#FFC414'
        strokeStyle = 'dashed'
        strokeWeight = 1
      }
      const polygon = new AMap.Polygon({
        path: path,
        strokeColor,
        strokeWeight,
        strokeOpacity: 1,
        fillOpacity: 0.4,
        fillColor,
        strokeStyle
      })
      // 添加缓存
      if (type === 'site') {
        this.cachePolygon.push(polygon)
      }
      vm.map && vm.map.add(polygon)
    },
    // 获取区域围栏
    getRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          selectAreaId: vm.selfAreaId
        }
        Api.getRail(params)
          .then((res) => {
            if (res.code === 200) {
              resolve(res)
            } else {
              console.log('获取区域围栏报错：')
            }
          })
          .catch((err) => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    // 获取禁行区围栏
    getEntryRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          selectAreaId: vm.selfAreaId
        }
        Api.getEntryRail(params)
          .then((res) => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning('获取区域围栏报错')
              reject(res)
            }
          })
          .catch((err) => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    showMapIcon(mapList, currentMap) {
      if (this.isHideLayer) {
        return
      }
      const vm = this
      vm.layer = new AMap.LabelsLayer({
        map: vm.map,
        zooms: [3, 20],
        zIndex: 201,
        collision: false,
        allowCollision: false
      })
      vm.map.addLayer(vm.layer)
      if (currentMap && currentMap.siteId) {
        mapList = [...mapList, currentMap]
      }
      const cMapList = JSON.parse(JSON.stringify(mapList))
      var markers = []
      // 虚拟站点处理
      if (currentMap && currentMap.siteId && currentMap.siteId.length === 13) {
        cMapList.unshift(currentMap)
      }
      cMapList.forEach((mark) => {
        const marker = new AMap.LabelMarker({
          name: mark.siteName,
          icon: {
            // 图标类型，现阶段只支持 image 类型
            type: 'image',
            // 图片 url
            image: mark.isBike
              ? blue3
              : vm.getIcon(
                vm.getSiteStatusByFlag(mark.flag).style,
                'url',
                mark.bleNum === 1,
                mark
              ),
            // 图片尺寸
            size:
              mark.bleNum === 1
                ? (currentMap && currentMap.siteId === mark.siteId) ||
                  mark.isBike
                  ? [56, 76] // 自动车的icon
                  : [34, 48] // 放大站点
                : (currentMap && currentMap.siteId === mark.siteId) ||
                  mark.isBike
                  ?
                  // (mark.siteId && mark.siteId.length === 13) ||
                  mark.recycleSwitch == 1
                    ? [46, 58] // 虚拟站点放大图
                    : [36, 54]
                  :
                  // (mark.siteId && mark.siteId.length === 13) ||
                  mark.recycleSwitch == 1
                    ? [36, 46] // 虚拟站点的图
                    : [26, 40], // 正常站点
            // 图片相对 position 的锚点，默认为 bottom-center
            anchor: 'center'
          },
          opacity: 1,
          zooms: [3, 20],
          id: mark.siteId,
          position: [mark.siteLon, mark.siteLat],
          zIndex: mark.isBike
            ? 300
            : vm.getSiteStatus(mark.currentNum, mark.siteBikeCeiling).zIndex,
          text: {
            content: mark.isBike ? '' : mark.currentNum + '',
            direction: 'center',
            offset:
              // (mark.siteId && mark.siteId.length === 13) ||
              mark.recycleSwitch == 1
                ? [-3, -3]
                : mark.bleNum === 1
                  ? [-4, -7]
                  : [0, -10],
            style: {
              fontSize: 12,
              fillColor: mark.isBike
                ? '#5691C9'
                : vm.getIcon(
                  vm.getSiteStatusByFlag(mark.flag).style,
                  'color',
                  mark.bleNum === 1,
                  mark
                )
            }
          }
        })
        if (mark.isBike) {
          console.log(blue3, 'blue3')
        } else {
          vm.getIcon(
            vm.getSiteStatusByFlag(mark.flag).style,
            'url',
            mark.bleNum === 1,
            mark
          )
        }
        if (mark.isBikeShowInfo) {
          marker.on('click', vm.showBikeInfoM.bind(vm, mark))
        } else {
          marker.on('click', vm.showInfoM.bind(vm, mark))
        }
        markers.push(marker)
      })
      vm.layer.add(markers)
    },
    mapMoveend() {
      // var { lng, lat } = vm.map.getCenter() // 获取当前中心点的经纬度
      // vm.map.panTo(new AMap.LngLat(lng, lat))
      // console.log(lng, '-----', lat, '-----地图移动结束')
      // this.map.add(vm.layer)
      this.map.addLayer(vm.layer)
      if (this.sizezoom == 14) {
        this.$emit('clearMapTimer')
      } else {
        this.$emit('refreshMap', this.map.getCenter())
      }
    },
    mapMovestart(e) {
      this.map.remove(vm.layer)
      this.map.removeLayer(vm.layer)
    },
    getSiteStatusByFlag(flag) {
      // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
      const obj = {
        style: '',
        status: ''
      }
      if (flag === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
        obj.zIndex = 220
      } else if (flag === 4) {
        obj.style = 1 // 偏少  黄色icon
        obj.status = '偏少'
        obj.zIndex = 230
      } else if (flag === 3) {
        obj.style = 3 // 偏多  橙色icon
        obj.status = '偏多'
        obj.zIndex = 250
      } else if (flag === 2) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
        obj.zIndex = 260
      } else {
        obj.style = 4 // 正常  绿色icon
        obj.status = '正常'
        obj.zIndex = 240
      }
      return obj
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: '',
        status: ''
      }
      // 修改前的状态： 0:空桩（蓝色）, 1:偏少（黄色）, 2:满桩（红色）, 3:偏多（橙色）, 4:正常（绿色）
      // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
      if (this.fullPileNum > 0) {
        if (curr === 0) {
          obj.style = 0 // 空桩  蓝色icon
          obj.status = '空桩'
          obj.zIndex = 220
        } else if (curr / Math.floor(total * this.fullPileNum) < 0.2) {
          obj.style = 1 // 偏少  黄色icon
          obj.status = '偏少'
          obj.zIndex = 230
        } else if (
          curr / Math.floor(total * this.fullPileNum) > 0.8 &&
          curr / Math.floor(total * this.fullPileNum) < 1
        ) {
          obj.style = 3 // 偏多  澄色icon
          obj.status = '偏多'
          obj.zIndex = 250
        } else if (curr / Math.floor(total * this.fullPileNum) >= 1) {
          obj.style = 2 // 满桩  红色icon
          obj.status = '满桩'
          obj.zIndex = 260
        } else {
          obj.style = 4 // 正常 绿色icon
          obj.status = '正常'
          obj.zIndex = 240
        }
        return obj
      }
      if (curr === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
        obj.zIndex = 220
      } else if (curr / total < 0.2) {
        obj.style = 1 // 偏少  黄色icon
        obj.status = '偏少'
        obj.zIndex = 230
      } else if (curr / total > 0.8 && curr / total < 1) {
        obj.style = 3 // 偏多  橙色icon
        obj.status = '偏多'
        obj.zIndex = 250
      } else if (curr / total >= 1) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
        obj.zIndex = 260
      } else {
        obj.style = 4 // 正常  绿色icon
        obj.status = '正常'
        obj.zIndex = 240
      }
      return obj
    },
    showEcharts() {
      alert('showEcharts')
    },
    showWindowPop(site) {
      const data = this.mapList.find((item) => item.siteId === site.siteId)
      if (data) {
        this.openInfo(data)
      }
    },
    openInfo(data) {
      // 构建信息窗体中显示的内容
      if (!this.railSwitch) {
        console.log(
          '站点弹窗',
          data,
          vm.getSiteStatus(data.currentNum, data.siteBikeCeiling)
        )
        vm.currentData = data
        let hasStationRatio
        if (vm.showRatioEdit && vm.ratioSites) {
          hasStationRatio = !this.ratioSites.find(
            (item) => item.siteId === data.siteId
          )
        }
        // console.log('vm.showRatioEdit', vm.showRatioEdit, 'vm.ratioSites', vm.ratioSites, 'hasStationRatio', hasStationRatio)
        let isVirtualSite = false
        if (data && data.siteId && data.siteId.length === 13) {
          isVirtualSite = true
        }
        var info = []
        // 修改前的状态： 0:空桩（蓝色）, 1:偏少（黄色）, 2:满桩（红色）, 3:偏多（橙色）, 4:正常（绿色）
        // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
        info.push(`
        <div class="map-title">
          <div class="title">${data.siteName}
            <span id='siteStatus' class="cursor ${
              data.flag === 0 // '空桩'
                ? 'blue map-title-tip'
                : data.flag === 4
                ? 'warning map-title-tip'
                : data.flag === 2
                ? 'red map-title-tip'
                : data.flag === 3
                ? 'origin map-title-tip'
                : 'map-title-tip'
            }">${vm.getSiteStatusByFlag(data.flag).status}</span>
            ${
              vm.showRatioEdit && hasStationRatio
                ? '<span class="des">勾选</span><input type="checkbox" id="ratioEdit"/>'
                : ''
            }
          </div>
        </div>
        <div class="map-content">
            <p class="content">
            站点编号：<span class="mt5">${data.siteId}</span>
            流向图：<span class="cursor" id="currentNumTwo">
             <i class="iconfont icon-zhexiantu" style="color:#00DADA"></i>
             </span>
            </p>
          <p class="content">创建时间：<span>${dateFormat(
            data.createTime,
            'yyyy-MM-dd hh:mm:ss'
          )}</span></p>
          <p class="content">
            道钉数：<span class="mt5">${data.bleNum}</span>
            车位数：<span class="mt5">${data.siteBikeCeiling}</span>
            现有车数：<span class="cursor" id="currentNum">${
              data.currentNum
            }
            <i class="iconfont icon-tubiao-zhexiantu" style="color:#00DADA"></i>
            </span>
          </p>
        </div>
        <div class="map-content-box cursor">
          <div class="bike cursor" id="mapContentBoxBike">
            <p class="title cursor">自行车：${data.bikeNum}</p>
            ${vm.getBrandBikeHTML(data.brandBike)}
          </div>
          <div class="ebike cursor">
            <p class="title cursor" id="mapContentBoxEBike">电动车: ${data.ebikeNum}</p>
            ${vm.getBrandEBikeHTML(data.brandEBike)}
          </div>
        </div>
        <span class="amap-num">${data.currentNum}</span>
        ${
          isVirtualSite
            ? '<span id="delSiteBtn" class="del-site-btn">删除站点</span>'
            : ''
        }
      `)
        vm.infoWindow = new AMap.InfoWindow({
          content: info.join('<br/>'), // 使用默认信息窗体框样式，显示信息内容
          anchor: 'middle-left',
          offset: new AMap.Pixel(25, -10)
        })
        vm.infoWindow.on('open', () => {
          vm.$emit('clearMapTimer', 'stop')
        })
        vm.infoWindow.on('close', () => {
          vm.$emit('clearMapTimer', 'start')
        })
        console.dir(vm.infoWindow.dom)
        vm.$nextTick((data) => {
          document
            .getElementById('siteStatus')
            .addEventListener('click', function () {
              vm.$emit('onInfoWindowClick', {
                ...vm.currentData,
                clickType: 3
              })
            })
          document
            .getElementById('currentNum')
            .addEventListener('click', function () {
              vm.$emit('onInfoWindowClick', {
                ...vm.currentData,
                clickType: 2
              })
            })
          document
            .getElementById('currentNumTwo')
            .addEventListener('click', function () {
              vm.rentMap(vm.currentData)
            })
          document
            .getElementById('mapContentBoxBike')
            .addEventListener('click', function () {
              vm.$emit('onInfoWindowClick', {
                ...vm.currentData,
                clickType: 1,
                bikeType: 0
              })
            })
          document
            .getElementById('mapContentBoxEBike')
            .addEventListener('click', function () {
              vm.$emit('onInfoWindowClick', {
                ...vm.currentData,
                clickType: 1,
                bikeType: 1
              })
            })
          if (document.getElementById('ratioEdit')) {
            document
              .getElementById('ratioEdit')
              .addEventListener('click', function (e) {
                vm.$emit('onInfoWindowClick', {
                  ...vm.currentData,
                  clickType: 4,
                  target: e
                })
              })
          }
          if (isVirtualSite) {
            document
              .getElementById('delSiteBtn')
              .addEventListener('click', function (e) {
                vm.$emit('onInfoWindowClick', {
                  ...vm.currentData,
                  clickType: 5,
                  target: e
                })
              })
          }
          // 绑定电动车品牌点击事件
          document.querySelectorAll('.brand-ebike').forEach(el => {
            el.addEventListener('click', function(e) {
              // 阻止冒泡到父元素
              e.stopPropagation()
              const brandId = this.getAttribute('data-brandId')
              vm.$emit('onInfoWindowClick', {
                ...vm.currentData,
                clickType: 1,
                bikeType: 1,
                brandId: brandId
              })
            })
          })
        })
        // map.getCenter() 是获取地图中心点的坐标，这里默认展示在地图中心。而不是标记点的位置
        console.log(data.siteLon)
        vm.infoWindow.open(vm.map, new AMap.LngLat(data.siteLon, data.siteLat))
        setTimeout(() => {
          const eles = document.getElementsByClassName('amap-info')
          // console.log('eles', eles)
          const ele = eles && eles[0]
          if (ele) {
            ele.style.zIndex = 9999
          }
        }, 2000)
      }
    },
    // 创建echarts车辆流向图
    rentMap(data, flag) {
      if (data === 'rentMap' || flag === 'isHideLayer' || flag === 'isShowLayer') {
        data = vm.chartData
      } else {
        vm.chartData = data
      }
      if (!flag) {
        this.onShowAmapBtn(false, true, true)
      }
      var mapListData = []
      if (flag !== 'isHideLayer' || flag === 'isShowLayer') {
        mapListData = vm.handleBubbleData()
      }
      const option = {
        //  加载 amap 组件
        amap: {
          // 高德地图中心经纬度
          center: [data ? data.siteLon : vm.currentData.siteLon, data ? data.siteLat : vm.currentData.siteLat],
          // 高德地图缩放
          zoom: vm.map.getZoom(),
          // 启用resize
          resizeEnable: true, // 允许缩放
          animateEnable: false,
          viewMode: '2D',
          zoomEnable: true, // 是否可滚轮缩放
          dragEnable: true, // 是否可拖拽
          keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
          showLabel: true,
          expandZoomRange: false,
          pitch: 60, // 3d有效
          showIndoorMap: false,
          // 自定义地图样式主题
          mapStyle: 'amap://styles/blue' // 地图主题
        },
        tooltip: {
          trigger: 'item',
          show: false
        },
        animation: false,
        series: [
          // 流线
          {
            coordinateSystem: 'amap', // 该系列使用的坐标系是高德地图的坐标系
            type: 'lines', // 该类型用于地图上路线的绘制
            zlevel: 1, // 相当于z-index
            effect: {
              show: true,
              smooth: false,
              trailLength: 0,
              symbol: 'arrow',
              symbolSize: [10, 20],
              constantSpeed: 20
            },
            lineStyle: {
              // 线的颜色
              normal: {
                color: '#def5f6',
                width: 2,
                curveness: 0.2
              }
            },
            data: flag === true ? [] : (data.rentBike ? data.rentBike : []),
            markPoint: { // 数据全是markPoint
              symbol: (value, params) => {
                params.symbol = this.chartBikeImage(params.data)
                return params.symbol
              },
              symbolSize: (value, params) => {
                params.symbolSize = this.chartImageSize(params.data)
                return params.symbolSize
              },
              itemStyle: {
                normal: {
                  borderColor: '#1e90ff',
                  borderWidth: 1, // 标注边线线宽，单位px，默认为1
                  label: {
                    show: true,
                    formatter: (params) => {
                      return params.data.isBike ? '' : params.data.currentNum + ''
                    },
                    position: 'top',
                    offset: [0, 25]
                  }
                },
                emphasis: {
                  borderColor: '#1e90ff',
                  borderWidth: 5,
                  label: {
                    show: false
                  }
                }
              },
              effect: {
                show: true,
                shadowBlur: 0
              },
              data: flag === true || flag === 'isHideLayer' ? [] : mapListData
            } // end markPoint
          }
        ]
      }
      const chart = echarts.init(document.getElementById('indexmap'))
      chart.setOption(option)
      // 图表渲染前销毁点击事件,防止点击图标多次触发
      chart.off('click')
      chart.on('click', function (param) {
        if (data.siteId !== param.data.siteId) {
          vm.rentData.push(data)
          var obj = {}
          vm.rentData = vm.rentData.reduce(function (prev, next) {
            obj[next.siteId] ? '' : obj[next.siteId] = true && prev.push(next)
            return prev
          }, [])
          const filterRentData = vm.rentData.filter((item) => {
            return item.siteId === param.data.siteId
          })
          console.log(filterRentData, 'filterRentData')
          // 数组对象转为对象
          var rentDataObj = {}
          filterRentData.forEach((item) => {
            console.dir(item, 'rentDataObj')
            rentDataObj = item
          })
          if (filterRentData.length <= 0) {
            const params = {
              selfAreaId: vm.selfAreaId,
              siteId: param.data.siteId,
              flowMapType: 1
            }
            vm.$nextTick(() => {
              Api.dashboardGetSite(params).then((res) => {
                if (res && res.code === 200) {
                  vm.rentData.push(res.data)
                  vm.rentMap(vm.handleChartData(res.data))
                }
              })
            })
          } else {
            vm.rentMap(rentDataObj)
          }
        }
      })
    },
    // 还车地图迁入图
    returnMap(data, flag) {
      if (data === 'returnMap' || flag === 'isHideLayer' || flag === 'isShowLayer') {
        data = vm.chartData
      } else {
        vm.chartData = data
      }
      this.onShowAmapBtn(true, false, true)
      var mapListData = []
      if (flag !== 'isHideLayer' || flag === 'isShowLayer') {
        mapListData = vm.handleBubbleData()
      }
      const option = {
        // 加载 amap 组件
        amap: {
          // 高德地图中心经纬度
          center: [data ? data.siteLon : vm.currentData.siteLon, data ? data.siteLat : vm.currentData.siteLat],
          // 高德地图缩放
          zoom: vm.map.getZoom(),
          // 启用resize
          resizeEnable: true, // 允许缩放
          animateEnable: false,
          viewMode: '2D',
          zoomEnable: true, // 是否可滚轮缩放
          dragEnable: true, // 是否可拖拽
          keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
          showLabel: true,
          expandZoomRange: false,
          pitch: 60, // 3d有效
          showIndoorMap: false,
          // 自定义地图样式主题
          mapStyle: 'amap://styles/blue' // 地图主题
        },
        geo: {
          map: 'amap',
          roam: true,
          type: 'map',
          zoom: 1.2
        },
        tooltip: {
          trigger: 'item',
          show: false
        },
        animation: false,
        series: [
          {
            type: 'effectScatter', // 点
            coordinateSystem: 'amap', // 选用坐标系
            // 出现涟漪动画的时机: render: 绘制完成后显示特效; emphasis: 高亮（hover）的时候显示特效
            showEffectOn: 'render',
            zlevel: 2,
            // 鼠标悬浮放大的效果
            hoverAnimation: false,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                color: '#3437ff',
                show: true
              }
            },
            // 折线拐点标志
            itemStyle: {
              normal: {
                color: 'rgba(47,68,200,0.1)',
                shadowBlur: 10
              }
            },
            // 拐点图形大小
            symbolSize: 5,
            markPoint: { // 数据全是markPoint
              symbol: (value, params) => {
                params.symbol = this.chartBikeImage(params.data)
                return params.symbol
              },
              symbolSize: (value, params) => {
                params.symbolSize = this.chartImageSize(params.data)
                return params.symbolSize
              },
              itemStyle: {
                normal: {
                  borderWidth: 1, // 标注边线线宽，单位px，默认为1
                  label: {
                    show: true,
                    formatter: (params) => {
                      return params.data.isBike ? '' : params.data.currentNum + ''
                    },
                    position: 'top',
                    offset: [0, 25]
                  }
                },
                emphasis: {
                  borderColor: '#1e90ff',
                  borderWidth: 5,
                  label: {
                    show: false
                  }
                }
              },
              effect: {
                show: true,
                shadowBlur: 0
              },
              data: flag === 'isHideLayer' ? [] : mapListData
            }
          },
          {
            type: 'lines', // 线
            coordinateSystem: 'amap',
            zlevel: 2,
            effect: {
              show: true,
              smooth: false,
              symbol: 'arrow',
              period: 5, // 特效动画的时间，单位为 s
              trailLength: 0, // 特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
              symbolSize: [10, 20],
              constantSpeed: 20
            },
            lineStyle: {
              normal: {
                color: '#def5f6',
                width: 2,
                opacity: 0.5, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
                curveness: 0.2 // 边的曲度，支持从 0 到 1 的值，值越大曲度越大
              }
            },
            // 流线起始点
            data: data.returnBike ? data.returnBike : []
          }
        ]
      }
      const chart = echarts.init(document.getElementById('indexmap'))
      chart.setOption(option)
      // 图表渲染前销毁点击事件,防止点击图标多次触发
      chart.off('click')
      chart.on('click', function (param) {
        if (data.siteId !== param.data.siteId) {
          vm.returnData.push(data)
          var obj = {}
          vm.returnData = vm.returnData.reduce(function (prev, next) {
            obj[next.siteId] ? '' : obj[next.siteId] = true && prev.push(next)
            return prev
          }, [])
          const filterReturnData = vm.returnData.filter((item) => {
            return item.siteId === param.data.siteId
          })
          console.log(filterReturnData, 'filterRentData')
          // 数组对象转为对象
          var returnDataObj = {}
          filterReturnData.forEach((item) => {
            console.dir(item, 'returnDataObj')
            returnDataObj = item
          })
          if (filterReturnData.length <= 0) {
            const params = {
              selfAreaId: vm.selfAreaId,
              siteId: param.data.siteId,
              flowMapType: 1
            }
            vm.$nextTick(() => {
              Api.dashboardGetSite(params).then((res) => {
                if (res && res.code === 200) {
                  vm.returnData.push(res.data)
                  vm.returnMap(vm.handleChartData(res.data))
                }
              })
            })
          } else {
            vm.returnMap(returnDataObj)
          }
        }
      })
    },
    destroyMap(flag) {
      this.onShowAmapBtn(false, false, false)
      // 销毁实例
      echarts.init(document.getElementById('indexmap')).dispose()
      if ((vm.user && vm.user.areaLevel > vm.userLevel) || !flag) {
        vm.$nextTick(() => {
          this.initMap([])
        })
      } else {
        vm.$parent.changeSiteSize(50)
        console.log(vm.initData)
      }
    },
    // 处理流向图数据
    handleChartData(data) {
      // 流入图还车数据
      const returnLine = []
      if (data.returnBike) {
        data.returnBike.forEach((item) => {
          const returnBike = JSON.parse(item.request)
          returnLine.push({
            coords: [
              [returnBike[0].bikeLon, returnBike[0].bikeLat],
              [data.siteLon, data.siteLat]
            ]
          })
        })
        console.log(returnLine, 'returnLine')
      }
      // 流出图租车数据
      const rentLine = []
      if (data.rentBike) {
        data.rentBike.forEach((item) => {
          const rentBike = JSON.parse(item.request)
          rentLine.push({
            coords: [
              [data.siteLon, data.siteLat],
              [rentBike[0].bikeLon, rentBike[0].bikeLat]
            ]
          })
        })
        console.log(rentLine, 'rentLine')
      }
      data.returnBike = returnLine
      data.rentBike = rentLine
      return data
    },
    // 处理流向图站点气泡数据
    handleBubbleData() {
      if (vm.currentMap && vm.currentMap.siteId) {
        vm.mapList = [...vm.mapList, vm.currentMap]
      }
      const cMapList = JSON.parse(JSON.stringify(vm.mapList))
      // 虚拟站点处理
      if (vm.currentMap && vm.currentMap.siteId && vm.currentMap.siteId.length === 13) {
        cMapList.unshift(vm.currentMap)
      }
      const mapListData = []
      cMapList.forEach((item) => {
        mapListData.push(
          {
            name: '全国',
            coord: [item.siteLon, item.siteLat],
            isBike: item.isBike,
            bleNum: item.bleNum,
            flag: item.flag,
            siteId: item.siteId,
            siteLon: item.siteLon,
            siteLat: item.siteLat,
            currentNum: item.currentNum,
            recycleSwitch: item.recycleSwitch,
            rentBike: item.rentBike,
            returnBike: item.returnBike,
            label: {
              color: item.isBike ? '#5691C9'
                : vm.getIcon(
                  vm.getSiteStatusByFlag(item.flag).style,
                  'color',
                  item.bleNum === 1,
                  item
                )
            }
          })
      })
      console.log(mapListData, 'mapListData')
      return mapListData
    },
    onShowAmapBtn(rentBtn, returnBt, amapBtn) {
      this.isShowRentBtn = rentBtn
      this.isShowReturnBtn = returnBt
      this.isShowAmapBtn = amapBtn
    },
    // 流向图气泡车辆图片
    chartBikeImage(data) {
      var bikeImageUrl = data.isBike
        ? blue3
        : vm.getIcon(
          vm.getSiteStatusByFlag(data.flag).style,
          'url',
          data.bleNum === 1,
          data
        )
      bikeImageUrl = 'image://' + bikeImageUrl
      return bikeImageUrl
    },
    // 流向图气泡图片尺寸
    chartImageSize(data) {
      const imageSize = data.bleNum === 1
        ? (vm.currentMap && vm.currentMap.siteId === data.siteId) ||
        data.isBike
          ? [56, 76] // 自动车的icon
          : [34, 48] // 放大站点
        : (vm.currentMap && vm.currentMap.siteId === data.siteId) ||
        data.isBike
          ? data.recycleSwitch == 1
            ? [46, 58] // 虚拟站点放大图
            : [36, 54]
          : data.recycleSwitch == 1
            ? [36, 46] // 虚拟站点的图
            : [26, 40]
      return imageSize
    },
    openBikeInfo(data) {
      // 构建信息窗体中显示的内容
      console.log('车辆弹窗', data)
      vm.currentData = data
      var info = []
      info.push(`
        <div style="height: 130px;">
          <div class="map-title">
            <div class="title">车辆编号：<span>${data.bikeId}</span></div>
          </div>
          <div class="map-content">
            <p class="content">车辆品牌：<span>${data.brandName}</span></p>
            <p class="content">车牌号码：<span>${data.licenseCode}</span></p>
          </div>
        </div>
      `)
      vm.infoWindow = new AMap.InfoWindow({
        content: info.join('<br/>'), // 使用默认信息窗体框样式，显示信息内容
        anchor: 'middle-left',
        offset: new AMap.Pixel(25, -10)
      })
      // map.getCenter() 是获取地图中心点的坐标，这里默认展示在地图中心。而不是标记点的位置
      vm.infoWindow.open(
        vm.map,
        new AMap.LngLat(
          data.siteLon != undefined ? data.siteLon : data.lon,
          data.siteLat != undefined ? data.siteLat : data.lat
        )
      )
    },
    showBikeInfoM(e) {
      const vm = this
      const data = vm.tableDataBrands.find(
        (item) => item.brandId === e.brandId
      )
      if (data) {
        e.brandName = data.brandName
        if (vm.infoWindow.close) {
          vm.infoWindow.close()
        }
        vm.openBikeInfo(e)
      } else {
        vm.infoWindow && vm.infoWindow.close()
      }
    },
    showInfoM(e) {
      if (e.isBike) {
        return false
      }
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        siteId: e.siteId
      }
      Api.dashboardGetSite(params).then((res) => {
        if (res && res.code === 200) {
          const data = res.data
          var text = '您在 xx 的位置点击了marker！'
          if (data.siteId) {
            if (vm.infoWindow.close) {
              vm.infoWindow.close()
            }
            // 流入图还车数据
            const returnLine = []
            if (data.returnBike) {
              data.returnBike.forEach((item) => {
                const returnBike = JSON.parse(item.request)
                returnLine.push({
                  coords: [
                    [returnBike[0].bikeLon, returnBike[0].bikeLat],
                    [data.siteLon, data.siteLat]
                  ]
                })
              })
              console.log(returnLine, 'returnLine')
            }
            // 流出图租车数据
            const rentLine = []
            if (data.rentBike) {
              data.rentBike.forEach((item) => {
                const rentBike = JSON.parse(item.request)
                rentLine.push({
                  coords: [
                    [data.siteLon, data.siteLat],
                    [rentBike[0].bikeLon, rentBike[0].bikeLat]
                  ]
                })
              })
              console.log(rentLine, 'rentLine')
            }
            data.returnBike = returnLine
            data.rentBike = rentLine
            vm.openInfo(data)
          } else {
            vm.infoWindow.close()
          }
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    showBikeInfoMBikeFeiFa(e) {
      if (e) {
        if (vm.infoWindow && vm.infoWindow.close) {
          vm.infoWindow.close()
        }
        const data = JSON.parse(JSON.stringify(e))
        data.siteLon = e.bikeLon
        data.siteLat = e.bikeLat
        vm.openBikeInfo(data)
      } else {
        vm.infoWindow && vm.infoWindow.close()
      }
    },
    getIcon2(name, type) {
      if (type === 1) {
        // 非法
        return ({
          哈啰电单: Illegal1,
          哈啰单车: Illegal1,
          人民出行: Illegal2,
          共驰出行: Illegal3,
          小遛共享: Illegal4,
          小骑时代: Illegal5,
          拜米出行: Illegal6,
          星骑出行: Illegal7,
          美团单车: Illegal8,
          美团电单: Illegal9,
          青桔电单: Illegal10,
          骑电出行: Illegal11,
          松果出行: Illegal12,
          摇一摇电单: Illegal13
        }[name] || Illegal14)
      } else if (type === 13) {
        // 站外投车
        return ({
          哈啰电单: castBlue,
          哈啰单车: castBlue,
          星骑出行: castRed,
          美团单车: castYellowBicycle,
          美团电单: castYellowBike,
          拜米出行: castGreen,
          小遛共享: castOrange,
          小骑时代: castPurple,
          青桔电单: castQing,
          闲驴出行: castYellowBike,
          人民出行: cast1,
          共驰出行: cast2,
          骑电出行: cast3,
          松果出行: cast4,
          瑶一瑶电单: cast5
        }[name] || cast6)
      } else if (type === 14) {
        // 超区停放
        return ({
          哈啰电单: strideBlue,
          哈啰单车: strideBlue,
          星骑出行: strideRed,
          美团单车: strideYellowBike,
          美团电单: strideYellowBike,
          拜米出行: strideGreen,
          共驰出行: stride1,
          小遛共享: strideOrange,
          小骑时代: stridePurple,
          青桔电单: strideQing,
          瑶一瑶电单: stride4,
          骑电出行: strideYellowish,
          人民出行: stride2,
          松果出行: stride3
        }[name] || stride5)
      } else {
        // 站外还车
        return (
          {
            哈啰电单: blue6,
            哈啰单车: blue6,
            星骑出行: red6,
            美团单车: orange6,
            美团电单: orange8,
            拜米出行: green6,
            小遛共享: yellow6,
            小骑时代: purple2,
            青桔电单: green8,
            闲驴出行: orange6,
            人民出行: outside1,
            共驰出行: outside2,
            骑电出行: outside3,
            松果出行: outside4,
            瑶一瑶电单: outside5
          }[name] || orange3
        )
      }
    },
    getIcon3(name, type) {
      return (
        {
          哈啰电单: {
            url: blue,
            color: '#1CA0FF'
          },
          星骑出行: {
            url: red,
            color: '#EE565D'
          },
          美团单车: {
            url: orange,
            color: '#FEEA5E'
          },
          美团电单: {
            url: yellow,
            color: '#FFCD51'
          },
          拜米出行: {
            url: green,
            color: '#6BD977'
          },
          小遛共享: {
            url: pink,
            color: '#FF935D'
          },
          小骑时代: {
            url: purple,
            color: '#8476D5'
          },
          青桔电单: {
            url: qing,
            color: '#3DD7A4'
          }
        }[name] || {
          url: green,
          color: '#6BD977'
        }
      )
    },
    getIcon(index, key, bleNum, site) {
      // 虚拟站点 index=4，key='url',bleNum=false,site=13为
      // 根据站点编号，13位的是虚拟站点
      // if (site && site.siteId && site.siteId.length === 13) {
      //   const style = [
      //     {
      //       url: site.recycleSwitch != 1 ? blue4 : blue7,
      //       color: '#5691C9',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: site.recycleSwitch != 1 ? orange4 : orange9,
      //       color: '#E7C23C',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: site.recycleSwitch != 1 ? red4 : red7,
      //       color: '#C33825',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: site.recycleSwitch != 1 ? yellow4 : yellow7,
      //       color: '#E7C23C',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: site.recycleSwitch != 1 ? green4 : green9,
      //       color: '#6DAE4E',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
      //       color: '#fff',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(19, 33)
      //     }
      //   ]
      //   return style[index][key]
      // }
      // if (site && site.siteId === '010579010179') {
      //   console.log('实体站点', index, key, bleNum, site)
      // }
      // 有临字的
      // if (bleNum) {
      //   const style = [
      //     {
      //       url: blue2,
      //       color: '#5691C9',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: orange2,
      //       color: '#E7C23C',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: red2,
      //       color: '#C33825',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: yellow2,
      //       color: '#E7C23C',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: green2,
      //       color: '#6DAE4E',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(26, 40)
      //     },
      //     {
      //       url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
      //       color: '#fff',
      //       anchor: new AMap.Pixel(0, 0),
      //       size: new AMap.Size(19, 33)
      //     }
      //   ]
      //   return style[index][key]
      // }
      // 无临字的
      const style = [
        {
          url: site.recycleSwitch != 1 ? blue1 : blue7,
          color: '#5691C9',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: site.recycleSwitch != 1 ? orange1 : orange9,
          color: '#E7C23C',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: site.recycleSwitch != 1 ? red1 : red7,
          color: '#C33825',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: site.recycleSwitch != 1 ? yellow1 : yellow7,
          color: '#E7C23C',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: site.recycleSwitch != 1 ? green1 : green9,
          color: '#6DAE4E',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
          color: '#fff',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(19, 33)
        }
      ]
      return style[index][key]
    },
    getBrandBikeHTML(brandBike) {
      let strBrandBike = ''
      if (brandBike && brandBike.length) {
        for (let i = 0; i < brandBike.length; i++) {
          const temp = brandBike[i]
          strBrandBike += `<p class="com cursor">${
            temp ? temp.brandName : ''
          }：<span class=" cursor" style="color:#00DADA">${
            temp.siteNum
          }</span></p>`
        }
      } else {
        strBrandBike = '<div style="color:#999;">暂无数据</div>'
      }
      return strBrandBike
    },
    getBrandEBikeHTML(brandEBike) {
      let strBrandEBike = ''
      if (brandEBike && brandEBike.length) {
        for (let i = 0; i < brandEBike.length; i++) {
          const temp = brandEBike[i]
          strBrandEBike += `<p class="com cursor">${
            temp ? temp.brandName : ''
          }：<span class="brand-ebike cursor" style="color:#00DADA"
          data-brandId="${temp.brandId}" >
           ${temp.siteNum}
         </span></p>`
        }
      } else {
        strBrandEBike = '<div style="color:#999;">暂无数据</div>'
      }
      return strBrandEBike
    },
    // 关闭信息窗体
    closeInfoWindow() {
      vm.map && vm.map.clearInfoWindow && vm.map.clearInfoWindow()
    },
    markLocation(mapId, address) {
      const vm = this
      if (address === '永康市') {
        address = '永康市政府'
      } else if (address === '全国' || !address) {
        address = '北京市天安门'
      } else if (address === '朝阳区' && vm.selfAreaId === '110105') {
        address = '北京市朝阳区'
      }
      AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder()
        geocoder.getLocation(address, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 经纬度
            var lng = result.geocodes[0].location.lng
            var lat = result.geocodes[0].location.lat
            // 地图实例
            vm.map = new AMap.Map(mapId, {
              resizeEnable: true, // 允许缩放
              center: [lng, lat], // 设置地图的中心点
              zoom: vm.sizezoom, // 设置地图的缩放级别，0 - 20
              animateEnable: false,
              viewMode: '2D',
              zoomEnable: true, // 是否可滚轮缩放
              dragEnable: true, // 是否可拖拽
              keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
              doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
              showLabel: true,
              expandZoomRange: false,
              pitch: 60, // 3d有效
              showIndoorMap: false,
              mapStyle: 'amap://styles/blue' // 设置地图的显示样式
            })
            // 添加标记
            var marker = new AMap.Marker({
              map: vm.map,
              position: new AMap.LngLat(lng, lat) // 经纬度
            })
            // 初始化围栏 - 2
            if (vm.userLevel >= 2) {
              vm.getRails()
            }
          } else {
            console.log('定位失败1！')
          }
        })
      })
    },
    changeSwitch() {
      if (!this.railSwitch) { // 激活绘制多边形
        this.drawPolygonSum()
        this.railSwitch = true
      } else { // 关闭绘制多边形
        this.railSwitch = false
        // 清除多边形
        vm.map.remove(vm.overlays)
        vm.isShowPolygonBtn = false
        vm.isShowPolygonSumBtn = false
        vm.overlays = []
      }
    }
  },
  watch: {
    currMap(val) {
      this.searchMap(val)
    }
  },
  beforeDestroy() {
    if (this.map && this.map.destroy) this.map.destroy()
    this.map = null
    this.closeInfoWindow()
    document.getElementById('currentNum') &&
      document
        .getElementById('currentNum')
        .removeEventListener('click', () => {})
    document.getElementById('mapContentBoxBike') &&
      document
        .getElementById('mapContentBoxBike')
        .removeEventListener('click', () => {})
    document.getElementById('mapContentBoxEBike') &&
      document
        .getElementById('mapContentBoxEBike')
        .removeEventListener('click', () => {})

    document.getElementById('currentNumTwo') &&
    document
      .getElementById('currentNumTwo')
      .removeEventListener('click', () => {})
    // 销毁MouseTool实例
    if (this.mouseTool) {
      this.mouseTool.close()
      this.mouseTool = null
    }
    // 清除所有图形
    this.cleanPolygon()
    // 解绑事件
    Utils.$off('cleanPolygon')
    if (this.map) {
      this.map.off('zoomend', this.zoomend)
      this.map.off('movestart', this.mapMovestart)
      this.map.off('moveend', this.mapMoveend)
      this.map.off('mapmove', this.throttle)
    }
  }
}
</script>

<style lang="less">
#indexmap {
  position: absolute !important;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  p {
    display: inline-block;
    color: #666;
  }

  .select-icon {
    position: absolute;
    top: 118px;
    left: -44px;
    font-size: 18px;
    display: inline-block;
    width: 45px;
    text-align: center;
  }

  .amap-num {
    position: absolute;
    top: 107px;
    left: -46px;
    display: block;
    width: 30px;
    text-align: center;
  }

  .del-site-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 6px;
    z-index: 1;
    cursor: pointer;
    color: #fff;
    /* border-bottom-right-radius: 6px; */
    border-radius: 4px;
    background-color: red;
  }

  .amap-icon {
    img {
      width: 30px;
      height: 45px;
    }
  }

  .amap-marker-label {
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    border: 0;
    padding: 0;
    top: -100px !important;
    left: 46px !important;
    z-index: 300;
  }

  .map-title-tip {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(121, 210, 77, 1);
    margin-left: 2px;
  }

  .amap-info-content {
    color: rgba(0, 0, 0, 0.65);
    background: #052430;
    border: 1px solid #3e7878;
    padding: 0;
    overflow: hidden;

    .map-content {
      padding: 0 16px 13px 16px;

      .content {
        display: block !important;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(255, 255, 255, 0.65);
        margin-bottom: 8px;

        span {
          color: rgba(255, 255, 255, 0.85);
        }

        span.mt5 {
          margin-right: 30px;
        }
      }
    }

    .map-content-box {
      display: flex;
      padding: 0 16px 16px 16px;

      div {
        flex: 1;

        p {
          display: block !important;
          margin-bottom: 8px;
        }
      }

      .bike,
      .ebike {
        p {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
        }

        .title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #fff !important;
        }
      }
    }

    .amap-info-close {
      position: absolute;
      right: 15px;
      top: 7px;
      color: #999999;
      text-decoration: none;
      font: inherit;
      width: 14px;
      height: 14px;
      cursor: pointer;
      font-size: 24px;
    }

    .map-title::after {
      position: absolute;
      bottom: 0;
      right: 16px;
      left: 16px;
      content: "";
      display: inline-block;
      height: 1px;
      background: #3e7878;
    }

    .map-title {
      position: relative;
      align-items: center;
      justify-content: space-between;
      display: flex;
      max-width: 300px;
      margin: 10px 0 16px 0;
      padding: 0 40px 10px 16px;
      border-bottom: 0;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #00dada;
        position: relative;
      }

      .close {
        display: inline-block;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        cursor: pointer;
      }

      .des {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
      }

      #ratioEdit {
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }

  .amap-info-sharp {
    border-right-color: #3e7878;
  }

  .cursor {
    cursor: pointer;
  }

  .ml6 {
    margin-left: 6px;
  }
}

.btn1,
.btn2,.btn3,.btn4,.btn5,.btn_map {
  position: absolute;
  z-index: 1000000;
  right: 30px;
  bottom: 77px;
  cursor: pointer;
}
.btn2 {
  bottom: 120px;
}
.btn3 {
  bottom: 165px;
}
.btn4 {
  bottom: 210px;
}
.btn5 {
  bottom: 255px;
}
.btn_map {
  bottom: 12px;
}
.el-button:focus, .el-button:hover {
  color: #def5f6;
  border-color: transparent;
  background-color: #0c3444;
}
.amap_move{
  background: #0c3444;
  border: none;
  padding: 5px 5px;
}
.amap_polygon {
  background: #052531;
  padding: 5px 5px;
  width: 310px;
  line-height: 21px;
  font-size: 14px;
  border: 1px solid #1a444b;
  background-size: 5px;
}
.amap_polygon:hover {
  background: #052531;
  border: 1px solid #1a444b;
  cursor: default;
}
.amap_cleanPolygon {
  background: #052430;
  padding: 5px 5px;
  border: 1px solid #00dada;
  color: #00dada;
  line-height: 20px;
  font-size: 10px;
  text-align: center;
}

.amap_cleanPolygon:hover {
  background: #052430;
  border: 1px solid #00dada;
  color: #F4F8F8;
  cursor:pointer;
}
.polygonStyleOne{
  pointer-events: initial;
}
.polygonStyleTwo{
  pointer-events: none;

}
*{
  user-select: text;
}

</style>
